export default {
  'traces.title': 'Listado de Trazas',
  'traces.text.actor': 'Actor',
  'traces.text.IsSuccessFullOperation': 'Operación Exitosa',
  'traces.text.entity': 'Entidad',
  'traces.text.entityDescription': 'Descripción de Entidad',
  'traces.text.environment': 'Entorno',
  'traces.text.operation': 'Operación',
  'traces.text.entityId': 'Identificador de Entidad',
  'traces.text.isSuccessfulOperation': '¿Operación Satisfactoria?',
  'traces.operation.add': 'Agregar',
  'traces.operation.addMany': 'Agregar Muchos',
  'traces.operation.update': 'Actualizar',
  'traces.operation.updateMany': 'Actualizar Muchos',
  'traces.operation.remove': 'Eliminar',
  'traces.operation.removeMany': 'Eliminar Muchos',
  'traces.operation.activate': 'Activar',
  'traces.operation.deactivate': 'Desactivar',
  'traces.operation.spCall': 'Llamada a SP',
  'traces.operation.query': 'Consulta',
  'traces.actor.user': 'Usuario',
  'traces.actor.system': 'Sistema',
  'traces.actor.anonymoususer': 'Usuario Anónimo',
  'traces.actor.rpaagent': 'Agente RPA',
  'traces.actor.processengine': 'Motor de Procesos',
  'traces.actor.webhook': 'Webhook',
};
